export default {
  name: 'float-search-bar',
  label: {
    title: '浮动搜索栏',
    icon: require('@/assets/icon-component-label_FloatSearchBar.svg'),
    limit: 1
  },
  tip: '注意:不可与浮动导航栏一起使用,会有相互遮盖问题',
  decor_type: 'admin',
  sort: 1002
}
